import React, {useState} from 'react';
import Avatar from "../../Components/Avatar";
import {v4 as uuidv4} from "uuid";
import { logOut, reset} from "../../../Features/Auth/authSlice";
import {useDispatch, useSelector} from "react-redux";
import {offCanvasReset} from "../../../Features/Misc/offCanvasSlice";
import {navBarReset} from "../../../Features/Misc/navBarSlice";
import {activeMediaReset} from "../../../Features/Misc/activeSlice";
import {activeReset} from "../../../Features/Misc/activeSlice";
import { persistor, persistConfig} from "../../../store";
import UnlockPremium from "./UserOffCanvasComponents/UnlockPremium";
import {resetLoginStep} from "../../../Features/Misc/loginSlice";

function UserOffCanvasMenuUser({userControls}) {


    //changed this
    const { first_name, last_name } = useSelector((state) => state.auth.user)

    //which tab is selected?
    const [currentTab, setCurrentTab] = useState(userControls[0].title)

    const dispatch = useDispatch()

    const handleLogout = () =>{
        dispatch(reset());
        dispatch(offCanvasReset());
        dispatch(navBarReset());
        dispatch(activeReset());
        dispatch(activeMediaReset());
        dispatch(resetLoginStep());
        dispatch(logOut());
        persistor.purge();
    }


    return (
        <div className="UserOffCanvasMenuUser hidden xl:grid bg-purple-slumber rounded-bl-mega  grid-cols-12 grid-rows-12  col-start-11 col-end-13 row-start-1 row-end-13">
            <div className="UserOffCanvasMenuUser__inner row-start-2 row-end-12 col-start-2 col-end-13  flex flex-col py-4 gap-14">
                <div className="avatarRow flex flex-row gap-2 items-center 2xl:gap-4">
                    <Avatar height={` h-12 `} width={` w-12 `} extraStyles={` min-w-12`} type={`user`}/>
                    <div className={`text-base `}>{first_name.charAt(0).toUpperCase() + first_name.slice(1).toLowerCase()} {last_name.charAt(0).toUpperCase() + last_name.slice(1).toLowerCase()}</div>
                    {/*changed this*/}
                </div>

                {userControls && userControls.map((userControl) => {
                        const {title, icon} = userControl

                        return(
                            <button
                                disabled={title === "Settings"}
                                key={uuidv4()}
                                onClick={() => setCurrentTab(title)}
                                className={`${currentTab === title ? "bg-gold-accent hover:bg-gold-accent-hover" : "bg-purple-slumber"} cursor-pointer w-11/12 h-14 rounded-lg gap-4 flex py-4 px-2 flex-row justify-start items-center ${title === "Settings" ? "opacity-0" : ""}`}
                            >
                                <i className={icon}></i>
                                <div className={`text-lg flex items-center justify-items`}>{title}</div>
                            </button>
                        )
                    }
                )}

                <div className={(currentTab === "log out" ? "bg-gold-accent hover:bg-gold-accent-hover" : "bg-purple-slumber") + ` cursor-pointer  w-full h-14 rounded-lg gap-4 flex p-4 px-2 flex-row justify-start items-center`}>
                    <i className="ri-logout-box-line"></i>
                    <div onClick={() => handleLogout()} className="logout text-xl">Log Out</div>
                </div>

                {/*disabled until implemented*/}
                {/*<UnlockPrem />*/}

            </div>

        </div>
    );
}

export default UserOffCanvasMenuUser;
